import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import swal from "sweetalert";
import Header from "../../../../components/Header";
import {
  ALL_COUNTIES,
  CREATE_COUNTY,
  UPDATE_COUNTY,
} from "../../../../data/SetupManagementData";

const CountyForm = (props) => {
  const { loading, error } = useQuery(ALL_COUNTIES);

  const [createCounty] = useMutation(CREATE_COUNTY, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "County has been created successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to create county, try again later", "error");
    },
  });

  const [updateCounty] = useMutation(UPDATE_COUNTY, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "County has been updated successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to update county, try again later", "error");
    },
  });

  const initialValues = {
    county: props.data ? props.data.county : "",
    countyCode: props.data ? props.data.countyCode : 0,
  };

  const validationSchema = yup.object().shape({
    county: yup.string().required("County is required"),
    countyCode: yup.string().required("County Code is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { county, countyCode } = values;

      if (props.isEditing) {
        props.onClose();
        await updateCounty({
          variables: {
            id: props.data.id,
            county,
            countyCode,
          },
        });
        console.log("County updated successfully!");
      } else {
        await createCounty({
          variables: {
            county,
            countyCode,
          },
        });
        console.log("County created successfully!");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit County" : "Create County"}
        subtitle={
          props.isEditing ? "Edit an Existing County" : "Create a New County"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="County *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.county}
                name="county"
                error={touched.county && !!errors.county}
                helperText={touched.county && errors.county}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="County Code *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.countyCode}
                name="countyCode"
                error={touched.countyCode && !!errors.countyCode}
                helperText={touched.countyCode && errors.countyCode}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CountyForm;
